import { useMutation, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useSelectPhotoModal(folder) {
  const { makeAuthedRequest } = Auth.useContainer();

  const uploadImage = useMutation(({ body }) => {
    return makeAuthedRequest(`v1/events/image`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(async (res) => {
      if (res.ok) return res.json();
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || "Upload failed");
    });
  });

  const fetchImages = useQuery(
    ["images", folder],
    async () => {
      const res = await makeAuthedRequest("v1/events/image");
      if (!res.ok) throw new Error("Failed to fetch images");
      const data = await res.json();
      return data;
    },
    { staleTime: 5 * 60 * 1000 }
  );

  return {
    uploadImage: uploadImage.mutate,
    isUploading: uploadImage.isLoading,
    images: fetchImages.data,
    isLoadingImages: fetchImages.isLoading,
    refetchImages: fetchImages.refetch,
  };
}
